module.exports = __webpack_public_path__ + "img/1251042793.60862479.jpg";